// removed by extract-text-webpack-plugin
module.exports = {"talkItem":"talkItem__35fd4","talkTitle":"talkTitle__2Awha","talkContentWrap":"talkContentWrap__Z14fB","talkContent":"talkContent__x-ai4","talkImage":"talkImage__3lwQ4","talkData":"talkData__Yg_gm"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Talk/TalkItem.css
// module id = 1475
// module chunks = 0